import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { SportMapItem } from '../../definitions/sport-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailMapItemLinkComponent, DetailViewModule } from '@ui/shared/ui-detail-view';
import { LinkedMapItem } from '../../definitions/linked-map-item';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-sport-map-item-details',
    templateUrl: './sport-map-item-details.component.html',
    styleUrls: ['./sport-map-item-details.component.scss'],
    imports: [
        DetailViewModule,
        DetailMapItemLinkComponent,
    ],
})
export class SportMapItemDetailsComponent implements MapItemComponent<SportMapItem> {
    @Output()
    public readonly mapItemTriggeredById = new EventEmitter<LinkedMapItem>();

    public mapItem = input<SportMapItem | undefined>();

    public triggerMapItemById(linkedItem: LinkedMapItem): void {
        this.mapItemTriggeredById.emit(linkedItem);
    }
}
